/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import { LuUtensilsCrossed } from "react-icons/lu";
import "./MenuSummaryBulletPicker.css";
import {
  SUMMARY_BULLET_START_DIGITS,
  SUMMARY_BULLET_UTENSILS,
  normalizeSummaryBulletStyle,
} from "../../../constants/summaryBulletStyle";

export default function MenuSummaryBulletPicker({
  value,
  onChange,
  idPrefix = "menu-summary-bullet",
}) {
  const { t } = useTranslation();
  const v = normalizeSummaryBulletStyle(value);

  return (
    <div className="menu-summary-bullet-picker menu-summary-align-picker">
      <h3 className="menu-summary-align-picker__title menu-summary-bullet-picker__title-extra">
        {t("menuSummaryBulletLabel")}
      </h3>
      <p className="menu-summary-align-picker__hint">{t("menuSummaryBulletHint")}</p>
      <div
        className="menu-summary-bullet-picker__grid"
        role="radiogroup"
        aria-label={t("menuSummaryBulletLabel")}
      >
        <button
          type="button"
          role="radio"
          aria-checked={v === SUMMARY_BULLET_UTENSILS}
          id={`${idPrefix}-${SUMMARY_BULLET_UTENSILS}`}
          className={`menu-summary-bullet-picker__tile ${
            v === SUMMARY_BULLET_UTENSILS ? "menu-summary-bullet-picker__tile--active" : ""
          }`}
          onClick={() => onChange(SUMMARY_BULLET_UTENSILS)}
        >
          <span className="menu-summary-bullet-picker__tile-visual" aria-hidden>
            <LuUtensilsCrossed size={20} strokeWidth={2} />
          </span>
          <span className="menu-summary-bullet-picker__tile-caption">
            {t("menuSummaryBulletUtensils")}
          </span>
        </button>
        {SUMMARY_BULLET_START_DIGITS.map((d) => (
          <button
            key={d}
            type="button"
            role="radio"
            aria-checked={v === d}
            aria-label={`${t("menuSummaryBulletStartFrom")} ${d}`}
            id={`${idPrefix}-start-${d}`}
            className={`menu-summary-bullet-picker__digit ${
              v === d ? "menu-summary-bullet-picker__digit--active" : ""
            }`}
            onClick={() => onChange(d)}
          >
            {d}
          </button>
        ))}
      </div>
    </div>
  );
}
